const UpcomingEvents = () => {
  let date = new Date();
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();

  return (
    <div className="past-events">
      <div className="past-event-card">
        <img src="https://imgur.com/UETNxmv.jpg" alt="event" />
        <div className="description">
          <h1>Event</h1>
          <p>📍abc, xyz</p>
          <p>📅{`${day}/${month}/${year}`}</p>
        </div>
      </div>
    </div>
  );
};

export default UpcomingEvents;
